import { __extends, __values } from "tslib";
import { action, computed, makeObservable } from 'mobx';
import { AbstractControl } from './abstract-control';
import { ControlTypes } from './сontrol-types';
var FormAbstractGroup = /** @class */ (function (_super) {
    __extends(FormAbstractGroup, _super);
    function FormAbstractGroup(
    /**
    * Function enable validation by condition (always enabled by default)
    * / Функция включение валидаций по условию (по умолчанию включено всегда)
    */
    activate, additionalData, type) {
        if (activate === void 0) { activate = null; }
        var _this = _super.call(this, activate, additionalData, type) || this;
        /**
        * Set marker "Value has changed"
        * / Установить маркер "Значение изменилось"
        */
        Object.defineProperty(_this, "setDirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (dirty) {
                var e_1, _a;
                try {
                    for (var _b = __values(_this.getControls()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var control = _c.value;
                        control.setDirty(dirty);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return _this;
            }
        });
        /**
         * Set marker "field was in focus"
         * / Установить маркер "Поле было в фокусе"
         */
        Object.defineProperty(_this, "setTouched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (touched) {
                var e_2, _a;
                try {
                    for (var _b = __values(_this.getControls()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var control = _c.value;
                        control.setTouched(touched);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return _this;
            }
        });
        Object.defineProperty(_this, "abbreviatedAND", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (getData) {
                var e_3, _a;
                try {
                    for (var _b = __values(_this.getControls()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var control = _c.value;
                        if (!getData(control)) {
                            return false;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                return true;
            }
        });
        Object.defineProperty(_this, "abbreviatedOR", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (getData) {
                var e_4, _a;
                try {
                    for (var _b = __values(_this.getControls()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var control = _c.value;
                        if (getData(control)) {
                            return true;
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                return false;
            }
        });
        makeObservable(_this, {
            processing: computed,
            invalid: computed,
            dirty: computed,
            touched: computed,
            focused: computed,
            setDirty: action,
            setTouched: action,
            allControls: action
        });
        return _this;
    }
    Object.defineProperty(FormAbstractGroup.prototype, "processing", {
        get: function () {
            return this.inProcessing || this.abbreviatedOR(function (control) { return control.processing; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormAbstractGroup.prototype, "invalid", {
        get: function () {
            return this.active && (this.errors.length > 0 || this.serverErrors.length > 0 || this.abbreviatedOR(function (control) { return control.invalid; }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormAbstractGroup.prototype, "dirty", {
        get: function () {
            return this.abbreviatedOR(function (control) { return control.dirty; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormAbstractGroup.prototype, "touched", {
        get: function () {
            return this.abbreviatedOR(function (control) { return control.touched; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormAbstractGroup.prototype, "focused", {
        get: function () {
            return this.abbreviatedOR(function (control) { return control.focused; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a complete list of FormControls without attachments (terminal elements)
     * Возвращает полный список FormControl-ов без вложений (терминальных элементов)
     */
    Object.defineProperty(FormAbstractGroup.prototype, "allControls", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var e_5, _a;
            var controls = [];
            try {
                for (var _b = __values(this.getControls()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var control = _c.value;
                    if (control.type === ControlTypes.Control) {
                        controls.push(control);
                    }
                    else if (control.type === ControlTypes.Group || control.type === ControlTypes.Array) {
                        controls = controls.concat(control.allControls());
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            return controls;
        }
    });
    return FormAbstractGroup;
}(AbstractControl));
export { FormAbstractGroup };
//# sourceMappingURL=form-abstract-group.js.map